<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
    <mat-form-field class="w-full">
        <mat-label>New Name</mat-label>
        <input
            matInput
            [placeholder]="data.placeholder || 'Enter new name'"
            [(ngModel)]="newName"
            (keydown.enter)="newName.trim() && rename()"
        />
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button (click)="cancel()">
        Cancel
    </button>

    <button mat-raised-button color="primary" (click)="rename()" [disabled]="!newName.trim()">
        Rename
    </button>
</mat-dialog-actions>
